import { useEndpoint } from '../../../../api/hooks/endpoint/useEndpoint';
import { getMenuColumnDefinition, MENU_TABS } from '../../../../schema/menu/menu.schema';
import { EntityTable } from '../../../common/entity-table/EntityTable';

export const MenuTable = () => {
  const menuQuery = useEndpoint('/menus', 'menus');

  return (
    <EntityTable
      query={menuQuery}
      getColumnDefinition={getMenuColumnDefinition}
      entityTabs={MENU_TABS()}
      entityName="Menu"
      canExport={false}
      single
    />
  );
};
